import { format, isValid, parseISO } from 'date-fns';
import { enGB, uk as ukLocale } from 'date-fns/locale';

import { ArtifactArchived, ArtifactSorting, ArtifactType } from './artifactsApi';

export const ARTIFACT_TYPE_LABELS: Record<ArtifactType, string> = {
  REPORT: 'Report',
  DASHBOARD: 'Dashboard',
  SOCIAL_GRAPH: 'Social graph',
};

export const SORTING_OPTIONS: { value: ArtifactSorting; label: string }[] = [
  { value: '-published_at', label: 'Newest first' },
  { value: 'published_at', label: 'Oldest first' },
  { value: 'title', label: 'Title (A–Z)' },
];

export const ARCHIVED_OPTIONS: { value: ArtifactArchived; label: string }[] = [
  { value: 'hide', label: 'Hide archived' },
  { value: 'include', label: 'Show archived' },
  { value: 'only', label: 'Archived only' },
];

const UK_LANGUAGES = ['uk', 'uk-UA', 'ua', 'ua-UK', 'ru', 'ru-RU'];

export function formatPublishedAt(iso: string | null, language: string): string {
  if (!iso) return '';
  const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/.test(iso);
  const date = parseISO(hasTimezone ? iso : `${iso}Z`);
  if (!isValid(date)) return iso;
  const isUk = UK_LANGUAGES.includes(language);
  return format(date, isUk ? 'd MMM yyyy' : 'MMM d, yyyy', {
    locale: isUk ? ukLocale : enGB,
  });
}

// CurrentUser context is untyped for these fields; keep the narrowing in one place
interface ArtifactUserShape {
  is_super_admin?: boolean;
  workspace?: { id?: number; config?: { roles?: string[] } };
}

export function getWorkspaceRoles(currentUser: unknown): string[] | undefined {
  return (currentUser as ArtifactUserShape | null)?.workspace?.config?.roles;
}

export function getIsSuperAdmin(currentUser: unknown): boolean {
  return Boolean((currentUser as ArtifactUserShape | null)?.is_super_admin);
}

export function getWorkspaceId(currentUser: unknown): number | undefined {
  return (currentUser as ArtifactUserShape | null)?.workspace?.id;
}

export interface FieldError {
  message: string;
  fieldId: string;
}

export function focusField(fieldId: string): void {
  const field = document.getElementById(fieldId);
  if (!field) return;
  field.scrollIntoView({ block: 'center', behavior: 'smooth' });
  field.focus({ preventScroll: true });
}
